module.exports = __webpack_public_path__ + "img/ai_body.95dd268a.png";